/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import {render} from '@canvas/react'

import {renderGameIntoDom} from './react/gameEntry'
import {NotFoundPage} from '@instructure/platform-generic-error-page'
import {canvasNotFoundTranslations} from '@canvas/error-page-utils'
import SVGWrapper from '@canvas/svg-wrapper'

export const renderNotFoundApp = domElementId => {
  const AppRootElement = document.getElementById(domElementId)
  if (AppRootElement) {
    return render(
      <NotFoundPage
        artwork={<SVGWrapper url="/images/not_found_page/empty-planet.svg" />}
        title={canvasNotFoundTranslations.title()}
        description={canvasNotFoundTranslations.description()}
      />,
      AppRootElement,
    )
  }
  return null
}

export const handleGameStartClick = event => {
  if (event.keyCode === 32) {
    document.body.removeEventListener('keydown', handleGameStartClick)
    renderGameIntoDom('not_found_root')

    // Trigger start command for game
    const startGameEvent = new KeyboardEvent('keydown', {
      keyCode: 32,
      bubbles: true,
      cancelable: true,
    })
    document.dispatchEvent(startGameEvent)
  }
}

if (!ENV.KILL_JOY) {
  document.body.addEventListener('keydown', handleGameStartClick)
}

renderNotFoundApp('not_found_root')
